// External libraries
import React from 'react';
import styled from 'styled-components';

// Zocdoc dependencies
import { blueLink } from '@zocdoc/branding/colors';
import {
    AppStoreBadge,
    FacebookInvertedRound,
    GooglePlayBadge,
    LinkedInInverted,
    Twitter,
    Instagram,
} from '@zocdoc-frontend-common/assets-icons';
import { Link } from '@zocdoc-frontend-common/components-link';

export function AppStoreLink({ height = 40, onBeforeLinkClick, ...props }) {
    return (
        <StyledIconLink
            beforeClick={onBeforeLinkClick}
            data-link-name="App Store"
            href="https://itunes.apple.com/us/app/zocdoc-doctor-appointments/id391062219?mt=8"
            rel="noopener noreferrer nofollow"
            target="_blank"
            title="Get the Zocdoc iPhone app on the App Store"
            {...props}
        >
            <AppStoreBadge height={height} />
        </StyledIconLink>
    );
}

export function GooglePlayLink({ height = 40, onBeforeLinkClick, ...props }) {
    return (
        <StyledIconLink
            beforeClick={onBeforeLinkClick}
            data-link-name="Google Play"
            href="https://play.google.com/store/apps/details?id=com.zocdoc.android"
            rel="noopener noreferrer nofollow"
            target="_blank"
            title="Get the Zocdoc Android app on Google Play"
            {...props}
        >
            <GooglePlayBadge height={height} />
        </StyledIconLink>
    );
}

export function InstagramLink({
    color,
    height = 40,
    onBeforeLinkClick,
    ...props
}) {
    return (
        <StyledIconLink
            beforeClick={onBeforeLinkClick}
            data-link-name="Instagram"
            href="https://www.instagram.com/zocdoc/"
            rel="noopener noreferrer nofollow"
            target="_blank"
            title="Follow Zocdoc on Instagram"
            {...props}
        >
            <Instagram color={color} height={height} />
        </StyledIconLink>
    );
}

export function FacebookLink({
    color = blueLink,
    height = 14,
    onBeforeLinkClick,
    ...props
}) {
    return (
        <StyledIconLink
            beforeClick={onBeforeLinkClick}
            data-element-name="Facebook"
            href="https://www.facebook.com/ZocDoc/"
            rel="noopener noreferrer nofollow"
            target="_blank"
            title="Like Zocdoc on Facebook"
            {...props}
        >
            <FacebookInvertedRound color={color} height={height} />
        </StyledIconLink>
    );
}

export function LinkedInLink({
    color = blueLink,
    height = 14,
    onBeforeLinkClick,
    ...props
}) {
    return (
        <StyledIconLink
            beforeClick={onBeforeLinkClick}
            data-element-name="LinkedIn"
            href="https://www.linkedin.com/company/zocdoc"
            rel="noopener noreferrer nofollow"
            target="_blank"
            title="Connect with Zocdoc on LinkedIn"
            {...props}
        >
            <LinkedInInverted color={color} height={height} />
        </StyledIconLink>
    );
}

export function TwitterLink({
    color = blueLink,
    height = 14,
    onBeforeLinkClick,
    ...props
}) {
    return (
        <StyledIconLink
            beforeClick={onBeforeLinkClick}
            data-element-name="Twitter"
            href="https://twitter.com/zocdoc"
            rel="noopener noreferrer nofollow"
            target="_blank"
            title="Follow Zocdoc on Twitter"
            {...props}
        >
            <Twitter color={color} height={height} />
        </StyledIconLink>
    );
}

const StyledIconLink = styled(Link)`
    border: none !important;
    display: block;
`;

/**
 * the !important's are to get around the styled(something) bug in
 * styled-components
 */

export const StyledGooglePlayLink = styled(GooglePlayLink)`
    margin-top: 9px !important;
`;
